// extracted by mini-css-extract-plugin
module.exports = {"AppIcon":"AppIcon_Tgrya"};